import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import UpdateDialog from '@/components/UpdateDialog.vue';
dayjs.locale('zh-cn');
export default {
  name: 'App',
  components: {
    UpdateDialog: UpdateDialog
  },
  data: function data() {
    return {
      locale: zhCN
    };
  }
};